import type { notifyModelDeleteAsyncActionFailedProps } from "./model-delete-async-action-failed.type";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";

export const notifyModelDeleteAsyncActionFailed = ({
  notify,
  title,
  payload,
}: notifyModelDeleteAsyncActionFailedProps) => {
  notify.error({
    key: payload.id,
    title,
    duration: ONE_MINUTE_IN_SECONDS,
  });
};
